import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React, { useId } from "react";
import { styled, useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { Icon } from "@sequentech/ui-essentials";
import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import { selectSlateListExpanded, setSlateListExpanded } from "../../store/extra/extraSlice";
var Toggle = styled("button")(function (_a) {
    var theme = _a.theme;
    return ({
        "display": "flex",
        "alignItems": "center",
        "justifyContent": "space-between",
        "width": "100%",
        "minHeight": "44px",
        "padding": "7px 0",
        "border": "none",
        "background": "none",
        "font": "inherit",
        "fontSize": "13px",
        "fontWeight": 500,
        "color": theme.palette.brandColor,
        "textAlign": "start",
        "cursor": "pointer",
        "&:focus-visible": {
            outline: "2px solid ".concat(theme.palette.brandColor),
            outlineOffset: "2px",
        },
    });
});
// On desktop the offices are laid out by the slate card, across cards.
var List = styled("div")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {},
        _b[theme.breakpoints.down("sm")] = {
            margin: "0 0 14px",
            padding: "0 12px",
            border: "1px solid #e7eaee",
            borderRadius: "6px",
            background: "#fbfcff",
        },
        _b[theme.breakpoints.up("sm")] = {
            display: "contents",
        },
        _b);
});
/**
 * The candidates of one slate. Always visible on desktop; on a phone the
 * voter can collapse it, starting from the state the election configures.
 * The toggle is kept for the ballot session and is never a vote.
 */
export var SlateCandidateList = function (_a) {
    var electionId = _a.electionId, slateId = _a.slateId, defaultExpanded = _a.defaultExpanded, children = _a.children;
    var t = useTranslation().t;
    var theme = useTheme();
    var dispatch = useAppDispatch();
    var listId = useId();
    var isPhone = useMediaQuery(theme.breakpoints.down("sm"));
    var stored = useAppSelector(selectSlateListExpanded(electionId, slateId));
    var expanded = !isPhone || (stored !== null && stored !== void 0 ? stored : defaultExpanded);
    return (_jsxs(_Fragment, { children: [isPhone && (_jsxs(Toggle, { type: "button", className: "slate-candidate-list-toggle", "aria-expanded": expanded, "aria-controls": listId, onClick: function () {
                    return dispatch(setSlateListExpanded({ electionId: electionId, slateId: slateId, expanded: !expanded }));
                }, children: [t(expanded ? "slates.candidateList.hide" : "slates.candidateList.show"), _jsx(Icon, { className: "slate-candidate-list-toggle-icon", icon: expanded ? faChevronUp : faChevronDown, "aria-hidden": "true" })] })), _jsx(List, { id: listId, className: "slate-candidate-list", hidden: !expanded, children: children })] }));
};
